/*
 Document Wizard
 - watches forms for changes
 - processes ajax form submissions and handles based on custom Processors added
*/

function Processor() {
  this.handlers = [];
  this.newData = null;
}

Processor.prototype.updateData = function(data){
  this.newData = data;
}

Processor.prototype.addHandler = function(fn, priority) {
  var newHandler = {
    'priority': priority || 0,
    'fn': fn
  }

  this.handlers.push(newHandler);
  if(this.handlers.length > 1) {
    this.sortHandlersByPriority();
  }
}

Processor.prototype.sortHandlersByPriority = function() {
  this.handlers.sort(function(a, b) {
    var priA = parseInt(a.priority),
      priB = parseInt(b.priority);

    return priB - priA;
  });
}

bq.documentWizard = function(element, options) {
  this.options   = options;
  this.$element  = $(element);
};

bq.documentWizard.DEFAULTS = {};

bq.documentWizard.prototype = {

  init: function () {
    var self = this;

    bq.debug.log("documentWizard : init()", this.$form);

    this._initEventHandlers();

    this.$element.on('bq.documentwizard.submit', function () {
      var formsToSubmit = $(this).find('form').toArray();

      formsToSubmit.forEach(function (form) {
        self._sendData({
          url: $(form).attr('action'),
          formData: $(form).serialize()
        });
      });
    });

    this.$element.on('bq.documentwizard.submitone bq.documentwizard.savesinglefield', function (e, data) {
      if(data.startCallback) {
        data.startCallback();
      }

      self._sendData(data);

    });

    this.$element.on('bq.documentwizard.lineactionsave', function(e, data) {
      if(!data.form) {
        bq.debug.log('Line Action Save requires a form element to be passed as argument.')
        return;
      }

      if(!data.clickedEl) {
        var $clickedEl = $();
      } else {
        var $clickedEl = $(data.clickedEl);
      }

      var $userInputs = data.form.find('input:not([type="hidden"]), select, textarea');
      bq.helper.throwEvent('bq.loadingbutton.start', $clickedEl);
      data.form.find('[data-line-action-cancel]').attr('disabled', 'disabled').hide();
      $userInputs.each(function (i, el) {
        $(el).attr('disabled', 'disabled');
      });

      self._sendData({
        url: data.url,
        formData: data.formData,
        successCallback: function() {
          bq.helper.throwEvent('bq.loadingbutton.success', $clickedEl);
          bq.helper.throwEvent('bq.documentwizard.form.updateinitialstate', $(data.form));

          if (data.successCallback) data.successCallback();
        },
        stopCallback: function() {
          $userInputs.each(function (i, el) {
            $(el).removeAttr('disabled');
            $(el).data('initialValue', $(el).val());
          });
        },
        errorsCallback: function() {
          bq.helper.throwEvent('bq.loadingbutton.error', $clickedEl);
        }
      });

    });

    this._addProcessor('messages', function (data, processor) {
      data.forEach(function (obj, ind) {
        bq.helper.throwEvent('bq.notification', $(document), {
            id: 'notification_bq-ui-' + obj.type + '-' + ind,
            text: obj.text,
            type: obj.type,
            delay: 10000
          });
      });
    }, 50);

    this._addProcessor('errors', function (data, processor) {
      data.forEach(function (obj, ind) {
        bq.helper.throwEvent('bq.notification', $(document), {
          id: 'notification_bq-ui-' + ind,
          text: obj.message,
          type: 'error',
          hide: obj.hide !== undefined ? obj.hide : true
        });
      })
    }, 100);

    this._addProcessor('updates', function (data, processor) {
      data.forEach(function (obj) {
        $(obj.selector).html(obj.content);
      });
      self._initEventHandlers();
      bq.helper.throwEvent('bq.onepage.update', self.$element);
    }, 200);

    this._addProcessor('forward', function (data, processor) {
      bq.helper.throwEvent('bq.viewhandler.keepspinner', self.$element);
      window.location.href = data;
    }, 300);

    this._addProcessor('success', function (data, processor) {
      if (data) {
        bq.helper.throwEvent('bq.onepage.savesuccess', self.$element);
      }
    });

    this._addProcessor('approvers', function(data, processor){
      setTimeout(function(){
        $('[data-bq="approvers"]').trigger('bq.approvers.update', data);
      }, 0);
    }, 400);

    this._addProcessor('budgets', function (data, processor) {
      bq.setAccountingBudgets(data);
    }, 500);
  },

  _initEventHandlers: function(){
    var self = this;
    this.$element.find('form, [data-form-container]').each(function (i, form) {
      var $form = $(form),
          eventType = $form.data('event-listen-to') || 'change';

      $form.data('initialState', self._serializeFields(form));

      $form.find('input, select, textarea').off(eventType);
      $form.find('input, select, textarea').each(function(){
        $(this).data('initialValue', $(this).val());
        $(this).on(eventType, function () {
          var newState = self._serializeFields(form);
          if($form.data('initialState') == newState){
            bq.helper.throwEvent('bq.documentwizard.form.unchanged', $form, $(this));
          } else {
            bq.helper.throwEvent('bq.documentwizard.form.changed', $form, $(this));
          }
        });
      });
      $form.on('bq.documentwizard.form.updateinitialstate', function(){
        $(this).data('initialState', self._serializeFields(this));
        $(this).removeClass('unsaved-line-action');
      });
    });
  },

  _serializeFields: function(node){
    if(node.nodeName == 'FORM'){
      return $(node).serialize();
    } else {
      return $(node).find(':input').serialize();
    }
  },

  _sendData: function (data) {
    var self = this,
        successCallback = data.successCallback || function () {},
        stopCallback = data.stopCallback || function () {},
        errorsCallback = data.errorsCallback || function () {};

    $.ajax({
      type: 'post',
      url: data.url,
      data: data.formData,
      success: function (resp) {
        var _resp;

        //If response is not JSON...
        if(resp[0] === "<") {
          errorsCallback();
          bq.helper.throwEvent('bq.viewhandler.stop', $('[data-view-handler]'));
          bq.helper.throwEvent('bq.notification', $(document), {
            id: 'notification_bq-ui-1',
            text: bq.messages.global.generalError,
            type: 'error'
          });
          setTimeout(function () {
            stopCallback();
          }, 2000);
          return;
        }

        _resp = JSON.parse(resp);
        self._processJSON(_resp);
        bq.helper.throwEvent('bq.viewhandler.stop', $('[data-view-handler]'));
        if(_resp.errors){
          errorsCallback();
        } else {
          successCallback();
        }
        setTimeout(function () {
          stopCallback();
        }, 2000);
      },
      error: function () {
        bq.helper.throwEvent('bq.viewhandler.stop', $('[data-view-handler]'));
        bq.helper.throwEvent('bq.notification', $(document), {
          id: 'notification_bq-ui-1',
          text: bq.messages.global.generalError,
          type: 'error'
        });
      }
    });

  },

  _addProcessor: function (key, fn, priority) {
    var newProcHandler = {};

    newProcHandler.priority = priority;
    newProcHandler.fn = fn;

    if (!this._processors[key]) {
      this._processors[key] = new Processor();
    }

    this._processors[key].addHandler(fn, priority);

  },

  _processors: {},

  _processJSON: function (obj) {

    var self = this,
      jsonObj = obj;

    for (var key in jsonObj) {
      if (this._processors[key] && this._processors[key]['handlers']) {
        self._processors[key]['handlers'].forEach(function (handler) {
          var _data = jsonObj[key];
          if (self._processors[key].newData) {
            _data = self._processors[key].newData;
          }
          handler.fn(_data, self._processors[key], self);
        });
      }
    }
  }
}

// documentWizard PLUGIN DEFINITION
// =======================

var documentWizardold = $.fn.documentWizard;

$.fn.documentWizard = function (option) {
  return this.each(function () {
    var $this   = $(this);
    var data    = $this.data('bq.documentWizard');
    var options = $.extend({}, bq.documentWizard.DEFAULTS, $this.data(), typeof(option) === 'object' && option);

    if (!data) { $this.data('bq.documentWizard', (data = new bq.documentWizard(this, options))); }
    data.init();
  });
};

$.fn.documentWizard.Constructor = bq.documentWizard;

// documentWizard NO CONFLICT
// =================

$.fn.documentWizard.noConflict = function () {
  $.fn.documentWizard = documentWizardold;
  return this;
};

// documentWizard DATA-API
// ==============

bq.documentWizardInit = function() {
  $('[data-bq="document-wizard"]').each(function () {
    var el = $(this);
    if(el.data('bq.documentWizard')) { return; }
    el.documentWizard(el.data());
  });
};

bq.init.push(bq.documentWizardInit);
